// Utility to format hours & minutes smartly
export const formatTime = (time: { hours?: number; minutes?: number } | null) => {
  if (!time) return "—";

  const hours = time.hours || 0;
  const minutes = time.minutes || 0;

  if (hours === 0 && minutes === 0) return "—";
  if (hours > 0 && minutes > 0) return `${hours}h ${minutes}m`;
  if (hours > 0) return `${hours}h`;
  if (minutes > 0) return `${minutes}m`;

  return "—";
};

export const logHourFormatTime = (time: { hours?: string; minutes?: string } | null) => {
  if (!time) return "—";

  const hours = parseInt(time.hours || "0", 10);
  const minutes = parseInt(time.minutes || "0", 10);

  if (hours === 0 && minutes === 0) return "";
  if (hours > 0 && minutes > 0) return `${hours}h ${minutes}m`;
  if (hours > 0) return `${hours}h`;
  if (minutes > 0) return `${minutes}m`;

  return "";
};


export const formatDate = (dateString: string): string => {
  if (!dateString) return "";

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return ""; // invalid date check

  return date.toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });
};

export const formatDateString = (dateString: string): string => {
  if (!dateString) return "";

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return ""; // invalid date check

  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  const year = date.getFullYear().toString().slice(-2);

  return `${month}/${day}/${year}`;
};


export const formatDateAgo = (dateString: string): string => {
  if (!dateString) return "Just now";

  const createdAt = new Date(dateString);
  const now = new Date();
  const diffMs = now.getTime() - createdAt.getTime();

  const diffSeconds = Math.floor(diffMs / 1000);
  const diffMinutes = Math.floor(diffMs / (1000 * 60));
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  if (diffSeconds < 60) {
    return "Just now";
  } else if (diffMinutes < 60) {
    return `${diffMinutes} minute${diffMinutes !== 1 ? "s" : ""} ago`;
  } else if (diffHours < 24) {
    return `${diffHours} hour${diffHours !== 1 ? "s" : ""} ago`;
  } else if (diffDays === 1) {
    return "Yesterday";
  } else if (diffDays < 7) {
    return `${diffDays} day${diffDays !== 1 ? "s" : ""} ago`;
  } else {
    // Older than a week → show formatted date
    return createdAt.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  }
};

export const formatDateStringType = (isoDateString: string) => {
  try {
    if (!isoDateString) return null;

    const date = new Date(isoDateString); // UTC → local
    if (isNaN(date.getTime())) return null;

    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();

    return `${month}-${day}-${year}`;
  } catch (error: any) {
    console.error("Error formatting date:", error.message);
    return null;
  }
};


export const getDateRangeFromData = (data: any) => {
  if (!data || data.length === 0) return "";

  // Get the first and last dates
  const startDateStr = data[0].date;
  const endDateStr = data[data.length - 1].date;

  // Parse dates using Date object
  const startDate = new Date(startDateStr);
  const endDate = new Date(endDateStr);

  // Format dates as "MMM D"
  const formatDate = (date: any) => {
    return date.toLocaleDateString("en-US", {
      month: "short", // e.g., "Jan"
      day: "numeric", // e.g., "6"
    });
  };

  // Return formatted range
  return `${formatDate(startDate)} - ${formatDate(endDate)}`;
};

export const notificationTimeFormat = (time: any) => {
  const now = Date.now();
  const diff = now - new Date(time).getTime();
  const minutes = Math.floor(diff / 60000);
  if (minutes < 1) return "just now";
  if (minutes < 60) return `${minutes} min ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} h ago`;
  return `${Math.floor(hours / 24)} d ago`;
}